import {
  SET_WORKERS,
  ADD_NEW_WORKER,
  DELETE_WORKER,
  SET_WORKERS_FOR,
  ADD_NEW_WORKER_FOR,
  DELETE_WORKER_FOR,
} from "redux/actions/workerActions";

const initialState = {
  myWorkers: [{ name: "DemoWorker" }],
  workersFor: [{ name: "DemoWorkerFor" }],
};

export const workerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WORKERS:
      console.log("workerReducer > SET_WORKERS... payload===", action.payload);
      return {
        ...state,
        myWorkers: action.payload,
      };
    case ADD_NEW_WORKER:
      console.log(
        "workerReducer > ADD_NEW_WORKER... payload===",
        action.payload
      );
      return {
        ...state,
        myWorkers: state.myWorkers.push(action.payload),
      };
    case DELETE_WORKER:
      console.log(
        "workerReducer > DELETE_WORKER... payload===",
        action.payload
      );
      {
        let tempWorkers = state.myWorkers.filter(
          (item) => item.workerId !== action.payload
        );
        return {
          ...state,
          myWorkers: state.myWorkers.push(action.payload),
        };
      }
    case SET_WORKERS_FOR:
      console.log(
        "workerReducer > SET_WORKERS_FOR... payload===",
        action.payload
      );
      return {
        ...state,
        workersFor: action.payload,
      };
    case ADD_NEW_WORKER_FOR:
      console.log(
        "workerReducer > ADD_NEW_WORKER_FOR... payload===",
        action.payload
      );
      return {
        ...state,
        workersFor: state.workersFor.push(action.payload),
      };
    case DELETE_WORKER_FOR:
      console.log(
        "workerReducer > DELETE_WORKER_FOR... payload===",
        action.payload
      );
      {
        let tempWorkers = state.workersFor.filter(
          (item) => item.workerId !== action.payload
        );
        return {
          ...state,
          workersFor: state.workersFor.push(action.payload),
        };
      }

    default:
      return state;
  }
};

export default workerReducer;
